<template>
    <v-dialog
    v-model='dialog'
    persistent
    max-width="80%"
    scrollable
  >
    <v-card>
      <v-card color="blue">
        <v-card-title flat class='white--text title'>{{item.title}}</v-card-title>
      </v-card>

      <v-card-text>
        <v-layout wrap>
          <v-flex class="mt-4">
            {{item.text}}
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          flat
          @click="reset()"
        >
          {{ 'BUTT_CANCEL' | translate}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//  import Vue from 'vue'
export default {
  name: 'DialogNotice',
  components: {},
  methods: {
    reset: function () {
      this.dialog = false
    },
    show (item) {
      this.item = item
      this.dialog = true
    }
  },
  data () {
    return {
      dialog: false,
      warning: false,
      item: {name: ''},
      currentCurrency: 1,
      warnMessage: ''
    }
  },
  mounted () {
    // Vue.prototype.$api.checkCredentials(this)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/dialogs/DialogNotice.vue